import Vue from 'vue';
import VueRouter from 'vue-router';
import { BASE_URL } from '@/config';
import routes from './routes';

//guards
import { authGuard } from '@/guards/auth.guard.js';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: BASE_URL,
  routes,
});

//navigation guard for auth
router.beforeEach(authGuard);

export default router;
